var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlasianLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.17,
    height: 56,
    viewBox: "0 0 54.17 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.273,
    y1: 0.215,
    x2: 0.284,
    y2: 0.824,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.252,
    y1: 0.797,
    x2: 0.737,
    y2: 0.172,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29915",
    "data-name": "Group 29915",
    transform: "translate(2112 3183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14758",
    "data-name": "Path 14758",
    d: "M53.517,26.433l-24.1-24.1L27.084,0,8.944,18.14l-8.3,8.293a2.223,2.223,0,0,0,0,3.135L17.222,46.14,27.084,56,45.222,37.86l.283-.28,8.013-8a2.218,2.218,0,0,0,0-3.148ZM27.084,36.28,18.8,28l8.28-8.28L35.362,28Z",
    transform: "translate(-2112.002 -3183)",
    fill: "#2684ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14759",
    "data-name": "Path 14759",
    d: "M53.8,19.923A13.938,13.938,0,0,1,53.738.27L35.62,18.38l9.86,9.86Z",
    transform: "translate(-2138.716 -3183.202)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14760",
    "data-name": "Path 14760",
    d: "M116.63,111.91l-8.3,8.3a13.942,13.942,0,0,1,0,19.715L126.5,121.77Z",
    transform: "translate(-2193.248 -3266.932)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasianLogo);
export default __webpack_public_path__ + "static/media/atlasian_logo.36539ae34c362cbe7cbf87b6ea883107.svg";
export { ForwardRef as ReactComponent };